var _rect, _path, _path2, _path3, _path4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDefault(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "url(#paint0_linear_19849_61860)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.134 22.5913V19.9995L10 23.1354C10.2806 26.9672 13.4848 29.9988 17.3867 29.9988H19.9784V26.842H17.3867C15.0414 26.842 13.134 24.9347 13.134 22.5913Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8406 17.4094V19.9993L29.9765 16.8634C29.6959 13.0335 26.4917 10 22.5898 10H19.998V13.1568H22.5898C24.9332 13.1568 26.8406 15.0641 26.8406 17.4094Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4094 13.1579H19.9993L16.8634 10.0239C13.0335 10.3026 10 13.5087 10 17.4106V20.0024H13.1568V17.4106C13.1568 15.0653 15.0641 13.1579 17.4094 13.1579Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1049 20.208L26.4205 23.7884L30.0009 25.104L26.4205 26.4195L25.1049 29.9999L23.7894 26.4195L20.209 25.104L23.7894 23.7884L25.1049 20.208Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_19849_61860",
    x1: 9.0804e-8,
    y1: 12.5,
    x2: 40,
    y2: 28.125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5082E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9455D3"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefault);
export default __webpack_public_path__ + "clientapp/media/default.3ff6e844.svg";
export { ForwardRef as ReactComponent };